/**
 * Builds Youtube urls
 * @param {string} src Video ID
 * @param {number} [startTime] Optional start time in seconds
 * @return {string} Youtube url for video
 */
interface BuildLink {
  src: string
  startTime?: number
}

export function buildLinkYoutube(payload: BuildLink): string {
  let t = null
  if (payload.startTime)
    t = `&t=${payload.startTime}s`
  return !payload?.src ? '' : `https://www.youtube.com/watch?v=${payload.src}${t || ''}`
}
